import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { lazyInject } from '../../ioc';
import { SubscriptionStore } from '../../stores/subscription.store';
import { observer } from 'mobx-react';
import { Preferences } from 'src/marketing/components/preferences/preferences';
import { BodyText, Headline } from '@servicetitan/design-system';

@observer
export class UnsubscribePageContainer extends React.Component<
    RouteComponentProps<{ emailId: string; version?: string }>
> {
    @lazyInject(SubscriptionStore) private marketingStore!: SubscriptionStore;

    componentDidMount(): void {
        this.marketingStore.unsubscribe(this.emailId);
    }

    private get emailId(): string {
        return this.props.match.params.emailId;
    }

    private get version(): string | undefined {
        return this.props.match.params.version;
    }

    render() {
        return (
            <Preferences
                header={
                    <React.Fragment>
                        <Headline bold>Unsubscribe Successful</Headline>
                        <BodyText size="xsmall" className="m-t-0 m-b-2">
                            You'll no longer receive email marketing from us.
                        </BodyText>
                    </React.Fragment>
                }
                emailId={this.emailId}
                version={this.version}
            />
        );
    }
}
